import { BenefitFormData } from '@/types/circuits/CircuitDaysFormData';
import { CircuitBenefitType } from '@/types/circuits/CircuitBenefitType';
import { getAssociatedBenefitColumnType } from './getAssociatedBenefitColumnType';
import { hasActiveAssociatedBenefits } from './hasActiveAssociatedBenefits';

export type AssociatedBenefitStepDisplay = {
  benefitId: string;
  name: string;
  columnType: Extract<CircuitBenefitType, 'Transport' | 'Activités'>;
  indexStepDay: number;
  stepNbDays: number;
};

export const getAssociatedBenefitsForStepDisplay = ({
  accommodationBenefit,
  indexStepDay,
  stepNbDays,
}: {
  accommodationBenefit?: BenefitFormData;
  indexStepDay: number;
  stepNbDays: number;
}): AssociatedBenefitStepDisplay[] => {
  const hotel = accommodationBenefit?.hotel;
  if (!hasActiveAssociatedBenefits(hotel)) return [];

  return (hotel?.associatedBenefits ?? []).flatMap((associatedBenefit) => {
    const isOnce = associatedBenefit.frequency === 'ONCE';
    const isEachNight = associatedBenefit.frequency === 'EACH_NIGHT';

    if (isOnce && indexStepDay !== 0) return [];
    if (!isOnce && !isEachNight) return [];

    const benefit = associatedBenefit.benefit;
    const name = benefit?.name ?? '';

    return [
      {
        benefitId: associatedBenefit.benefitId,
        name,
        columnType: getAssociatedBenefitColumnType(
          benefit?.activity?.activityType,
        ),
        indexStepDay: isOnce ? 0 : indexStepDay,
        stepNbDays: isOnce ? 1 : stepNbDays,
      },
    ];
  });
};
